import { Card, Form, Input, Button } from "antd";
import Parse from "parse";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function ForgotPassword() {
  const navigate = useNavigate();

  const handleSubmit = async ({ email }) => {
    try {
      const response = await Parse.Cloud.run("requestPasswordReset", { email: email.trim().toLowerCase() });

      if (response.success) {
        toast.success("We have sent an email with a reset password link. Open your email and click the link to assign a new password.");
        navigate("/login");
      } else {
        console.error(response);
        toast.error("We couldn't send the password reset email. Please try again.");
      }
    } catch (error) {
      console.error(error);
      toast.error("We couldn't send the password reset email. Please try again.");
    }
  };

  return (
    <div
      className="relative w-full min-h-screen overflow-hidden flex flex-col"
      style={{
        backgroundImage: "url('/images/atomfi_background.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <h1 className="text-right font-bold text-xl mb-4 w-full mt-8 !-ml-10 text-white">NomyxID</h1>
      <div className="flex flex-1 flex-col lg:flex-row">
        {/* Left Side */}
        <div className="w-full lg:w-1/2 flex flex-col items-center justify-center px-4 md:px-6 my-10" />

        <div className="max-[550px]:hidden w-1/2 flex flex-col justify-center items-center p-2">
          {/* Right Side */}
          <div className="w-full lg:w-3/4 flex items-center justify-center px-4 md:px-6">
            <div className="bg-nomyxDark1 bg-opacity-90 text-nomyxWhite shadow-lg rounded-lg p-4 max-w-2xl w-full">
              <div className="w-full flex flex-col justify-center items-center">
                <Card
                  title={<span className="text-white">Forgot Password</span>}
                  style={{
                    width: "100%",
                    maxWidth: "550px",
                    border: "none",
                  }}
                  className="signup-card bg-transparent shadow-lg rounded-lg"
                >
                  <p className="mb-6 text-left text-white font-normal text-sm">Enter your email, and we will send you a password reset link.</p>
                  <Form layout="vertical" onFinish={handleSubmit} className="w-full">
                    <Form.Item
                      name="email"
                      label={<span className="text-gray-400">Email</span>}
                      rules={[
                        { required: true, message: "Please input your Email!" },
                        { type: "email", message: "Please enter a valid email address!" },
                      ]}
                    >
                      <Input type="email" placeholder="Enter your email" className="signup-input placeholder-nomyxGray1 !border-nomyxGray1" />
                    </Form.Item>

                    <Form.Item>
                      <div className="flex justify-between items-center">
                        <Link to="/login" className="text-blue-500 font-semibold">
                          Back to Login
                        </Link>
                        <Button type="primary" htmlType="submit" className="signup-button">
                          Submit
                        </Button>
                      </div>
                    </Form.Item>
                  </Form>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
